import Rich from 'components/rich/rich'
import certificateTypeOptions from 'utils/data/certificateTypes'

export default function Privacy({ account }) {
    return <Rich content={getPrivacy(account)} />
}

function getPrivacy(account) {
    if (!account) return

    const {
        is_company,
        updated_date,
        person_name,
        person_certificate_nr,
        person_certificate_type,
        person_address,
        email,
        company_name,
        company_address,
        company_code
    } = account

    if (is_company) {
        return `<p>
                    <strong>
                        ${company_name.toUpperCase() || '[...]'}
                        PRIVATUMO POLITIKA ASMENIMS SIUNČIANTIEMS PAKLAUSIMUS, PRAŠYMUS, SKUNDUS
                    </strong>
                </p>
                <p>Paskutinė atnaujinimo data: ${updated_date}</p>
                <p>
                    ${company_name || '[...]'} rūpinasi Jūsų informacijos apsauga. Mes laikomės Europos Sąjungos
                    Bendrojo duomenų apsaugos reglamento (BDAR) bei kitų įstatymų, saugančių Jūsų informaciją, kurią
                    renkame, naudojame ir saugome savo Bendrovėje.
                </p>
                <p>
                    <strong>1. Kaip turėčiau skaityti šią Privatumo politiką?</strong>
                </p>
                <p>
                    Šiame pranešime bus atsakyta į svarbiausius klausimus apie tai, kaip mes renkame, naudojame ir
                    saugome informaciją apie Jus, perkant prekes iš mūsų per lietuviskapreke.lt platformą. Jei turite
                    kokių nors klausimų arba bet kuri iš šio pranešimo dalis yra neaiški, mes esame pasirengę Jums
                    padėti, kaip aprašyta šios Privatumo politikos 10 skyriuje. Prašome atkreipti dėmesį, kad bet kokia
                    žodžio &bdquo;mes&ldquo; forma šioje Privatumo politikoje reiškia mūsų Bendrovę, kaip nurodyta
                    Privatumo politikos 2 skyriuje.
                </p>
                <p>
                    <strong>2. Kas yra atsakingas už mano informacijos apsaugą?&nbsp;</strong>
                </p>
                <p>Mes esame: ${company_name || '[...]'};</p>
                <p>Mūsų juridinio asmens kodas yra: ${company_code || '[...]'};</p>
                <p>Mūsų adresas: ${company_address || '[...]'};</p>
                <p>El. pašto adresas: ${email || '[...]'}.</p>
                <p>
                    <strong>3. Kodėl renkate informaciją apie mane?</strong>
                </p>
                <p>Mes Jūsų duomenis renkame, naudojame ir saugome dėl šių priežasčių:</p>
                <ul>
                    <li>
                        kad galėtumėme įvykdyti Jūsų užsakymą ir pristatyti Jums prekes &ndash; Jūsų asmens duomenys
                        naudojami užsakymo apdorojimui bei užsakytų prekių pristatymui ir jo organizavimui;
                    </li>
                    <li>
                        kad galėtumėme įvykdyti mums taikomas prievoles buhalterinės apskaitos bei dokumentų archyvavimo
                        srityse;
                    </li>
                    <li>
                        gaunamų užklausų administravimui &ndash; jei pateiksite mums užklausą platformoje
                        lietuviskapreke.lt nurodytais mūsų kontaktais, Jūsų asmens duomenys bus naudojami šio paklausimo
                        administravimui (susipažinimui, atsakymo parengimui, saugojimui pagal teisės aktų reikalavimus);
                    </li>
                    <li>
                        savo teisėtų interesu gynybai &ndash; jei tai būtų reikalinga, Jūsų asmens duomenis galime
                        panaudoti gindami savo teisėtus interesus, įskaitant reputaciją, teismuose, ikiteisminėse ginčų
                        sprendimo institucijose bei kitose kompetentingose institucijose.
                    </li>
                </ul>
                <p>
                    <strong>4. Kokią informaciją turėčiau Jums pateikti ir kodėl?</strong>
                </p>
                <p>Pateikdami užsakymą Jūs turėtumėte mums pateikti šią informaciją apie save:</p>
                <ul>
                    <li>savo vardą ir pavardę;</li>
                    <li>telefono numerį;</li>
                    <li>
                        prekių pristatymo adresą (miestas, adresas, pašto kodas) arba pasirinktą paštomatą/terminalą ar
                        pašto skyrių, į kurį turi būti pristatomos Jūsų užsakytos prekės.
                    </li>
                </ul>
                <p>Be šios informacijos mes negalėsime įvykdyti Jūsų užsakymo ar pristatyti Jums prekių.</p>
                <p>
                    <strong>5. Koks yra teisinis informacijos apie mane rinkimo pagrindas?</strong>
                </p>
                <p>Mes renkame ir saugome informaciją apie Jus teisėtai, nes:&nbsp;</p>
                <ul>
                    <li>
                        Jūsų asmens duomenis pateikto užsakymo vykdymo ir prekių pristatymo tikslu mes naudojame
                        pirkimo-pardavimo sutarties vykdymui, kurią su mumis sudarote pateikdami užsakymą (BDAR 6 str. 1
                        d. b p.);
                    </li>
                    <li>
                        Jūsų asmens duomenys yra reikalingi, kad galėtumėme tinkamai vykdyti mums taikomas teisines
                        prievoles buhalterinės apskaitos bei dokumentų archyvavimo srityse (BDAR 6 str. 1 d. c p.);
                    </li>
                    <li>
                        mes turime teisėtą interesą administruoti gaunamas užklausas (BDAR 6 str. 1 d. f p.), o jei Jūsų
                        užklausa bus susijusi su Jūsų užsakymu &ndash; ji bus laikoma pirkimo-pardavimo sutarties dalimi
                        ir Jūsų asmens duomenys bus tvarkomi pirkimo-pardavimo sutarties vykdymo pagrindu (BDAR 6 str. 1
                        d. b p.);
                    </li>
                    <li>
                        mes turime teisėtą interesą ginti savo teises teismuose ar kitose institucijose (BDAR 6 str. 1
                        d. f p.).
                    </li>
                </ul>
                <p>
                    <strong>6. Ar Jūs renkate jautrią informacija apie mane?</strong>
                </p>
                <p>
                    Jautri informacija apie Jus nėra renkama ir, jei ji nėra aktuali Jūsų pateiktam ar planuojamam
                    užklausai, prašome jos neteikti. Jei vis dėl to tokia informacija bus pateikta, laikysime, kad
                    davėte mums sutikimą šios informacijos tvarkymui (BDAR 9 str. 2 d. a p.).
                </p>
                <p>
                    <strong>7. Ar dalinatės mano informacija su kitais subjektais?</strong>
                </p>
                <p>Informacija apie Jus gali būti perduota:&nbsp;</p>
                <ul>
                    <li>
                        prekybos tarpininkui &ndash; bendrovei MB &bdquo;Pavojingos idėjos&ldquo;, kuri valdo
                        lietuviskapreke.lt platformą;
                    </li>
                    <li>buhalterinių paslaugų teikėjams;</li>
                    <li>archyvavimo paslaugų teikėjams;</li>
                    <li>duomenų saugyklų paslaugų teikėjams;</li>
                    <li>el. pašto paslaugų teikėjams, jei užklausas mums siųsite el. paštu;</li>
                    <li>
                        teisines paslaugas teikiančioms bendrovėms, advokatų kontoroms, kiek tai reikalinga mūsų teisėtų
                        interesų gynybai;
                    </li>
                    <li>
                        teismams, ikiteisminėms ginčų sprendimo institucijoms, kiek tai reikalinga mūsų teisėtų interesų
                        gynybai;
                    </li>
                    <li>antstoliams, kiek tai reikalinga priteistų sumų išieškojimui.</li>
                </ul>
                <p>
                    <strong>8. Kiek laiko saugote informaciją apie mane?</strong>
                </p>
                <p>Jūsų informacija bus saugoma:</p>
                <ul>
                    <li>
                        jei jūsų užklausą susijusi su Jūsų užsakymu, ji bus saugoma 10 metų po pirkimo-pardavimo
                        sutarties pabaigos, t. y. po prekių pristatymo;
                    </li>
                    <li>
                        jei mums pateikėte skundą, prašymą ar kitokią užklausą, kuri nėra susijusi su Jūsų užsakymu, ją
                        saugosime 1 metus nuo sprendimo mūsų bendrovėje priėmimo;
                    </li>
                    <li>informaciją apie Jūsų užsakymą, įskaitant išrašytą sąskaitą saugosime 10 metų;</li>
                    <li>
                        teismams ar kitoms ginčus nagrinėjančioms ar teisėsaugos institucijoms teikiami dokumentai
                        saugomi 1 metus po galutinio sprendimo priėmimo;
                    </li>
                    <li>teismų vykdomieji raštai, antstolių patvarkymai saugomi 10 metų po mokėjimų pabaigos.</li>
                </ul>
                <p>
                    <strong>9. Kokių veiksmų galiu imtis dėl savo informacijos Jūsų bendrovėje?</strong>
                </p>
                <p>
                    Jei norite imtis žemiau nurodytų veiksmų, prašome kreiptis į mus, kaip tai nurodyta 10 skyriuje.
                    Atkreipiame dėmesį, kad šioms teisėms gali būti taikomos įstatymų numatytos išimtys bei ribojimai.
                    Jūs turite šias teises duomenų apsaugos srityje:
                </p>
                <ul>
                    <li>
                        pateikti prašymą susipažinti su turima informacija apie Jus, jei tvarkome Jūsų asmens duomenis,
                        iš kurių galime nustatyti Jūsų tapatybę;
                    </li>
                    <li>pateikti prašymą ištaisyti ar papildyti turimą informaciją apie Jus;</li>
                    <li>
                        pateikti prašymą ištrinti apie Jus, kai:
                        <ul>
                            <li>Jūsų duomenis tvarkome sutikimo pagrindu;</li>
                            <li>Jūsų duomenis tvarkome neteisėtai;</li>
                            <li>
                                Jūsų duomenys tvarkomi mūsų teisėto intereso pagrindu ir Jūs nuginčijate mūsų teisėtą
                                interesą;
                            </li>
                            <li>
                                Jūsų duomenys nebėra reikalingi, kad būtų pasiekti tikslai, kuriems jie buvo renkami;
                            </li>
                            <li>mums taikoma teisinė prievolė ištrinti informaciją apie Jus;</li>
                        </ul>
                    </li>
                    <li>
                        pateikti mums prašymą apriboti apie Jus turimos informacijos tvarkymą kai ginčijate duomenų
                        tikslumą ar prieštaraujate duomenų tvarkymui, nesutinkate, kad būtų ištrinti neteisėtai tvarkomi
                        Jūsų duomenys, ar duomenų Jums reikia, siekiant pareikšti, vykdyti arba apginti teisinius
                        reikalavimus;
                    </li>
                    <li>
                        ginčyti Jūsų informacijos rinkimą, naudojimą ir saugojimą mūsų bendrovėje, kai tvarkydami Jūsų
                        duomenis vadovaujamės teisėtų interesu kaip duomenų tvarkymo pagrindu;
                    </li>
                    <li>
                        pateikti prašymą išeksportuoti Jūsų duomenis jei duomenis mums pateikėte susistemintu, įprastai
                        naudojamu formatu ir davėte sutikimą tokių duomenų tvarkymui arba turime tvarkyti šiuos duomenis
                        siekdami įvykdyti sutartį su Jumis;
                    </li>
                    <li>
                        pateikti skundą Valstybinei duomenų apsaugos inspekcijai (daugiau informacijos vdai.lrv.lt).
                    </li>
                </ul>
                <p>
                    <strong>10. Kaip galite man padėti?</strong>
                </p>
                <p>
                    Jeigu Jūs turite klausimų, komentarų ar nusiskundimų, susijusių su tuo, kaip mes renkame, naudojame
                    ir saugome duomenis apie Jus, mes esame pasirengę Jums padėti. Jei Jums reikalinga mūsų pagalba,
                    prašome kreiptis el. paštu ${email}.
                </p>`
    }

    return `<p>
                <strong>
                    PRIVATUMO POLITIKA ASMENIMS SIUNČIANTIEMS PAKLAUSIMUS, PRAŠYMUS, SKUNDUS
                </strong>
            </p>
            <p>Paskutinė atnaujinimo data: ${updated_date}</p>
            <p>
                Jums perkant prekes yra užtikrinama Jūsų informacijos apsauga. Renkant, naudojant bei saugant Jūsų
                asmens duomenis yra laikomasi Europos Sąjungos Bendrojo duomenų apsaugos reglamento (BDAR) bei kitų
                įstatymų, saugančių Jūsų asmens duomenis.
            </p>
            <p>
                <strong>1. Kaip turėčiau skaityti šią Privatumo politiką?</strong>
            </p>
            <p>
                Šiame pranešime bus atsakyta į svarbiausius klausimus apie tai, kaip yra renkami,
                naudojami ir saugomi Jūsų asmens duomenys, perkant prekes per lietuviskapreke.lt platformą. Jei turite
                kokių nors klausimų arba bet kuri iš šio pranešimo dalis yra neaiški,
                prašome susisiekti 10 skyriuje nurodytais kontaktais.
            </p>
            <p>
                <strong>2. Kas yra atsakingas už mano informacijos apsaugą?</strong>&nbsp;
            </p>
            <p>Atsakingas asmuo: ${person_name || '[...]'};</p>
            <p>
                ${certificateTypeOptions.find(t => t.value === person_certificate_type).name}:
                ${person_certificate_nr || '[...]'};
            </p>
            <p>Adresas: ${person_address || '[...]'};</p>
            <p>El. pašto adresas: ${email || '[...]'}.</p>
            <p>
                <strong>3. Kodėl renkate informaciją apie mane?</strong>
            </p>
            <p>Jūsų asmens duomenys yra renkami, naudojami ir saugomi dėl šių priežasčių:</p>
            <ul>
                <li>
                    Jūsų užsakymą įvykdymui ir prekių pristatymui &ndash; Jūsų asmens duomenys naudojami užsakymo
                    apdorojimui bei užsakytų prekių pristatymui ir jo organizavimui;
                </li>
                <li>taikomas teisinių prievolių buhalterinės apskaitos bei dokumentų archyvavimo srityse įvykdymui;</li>
                <li>
                    gaunamų užklausų administravimui &ndash; jei pateiksite užklausą platformoje lietuviskapreke.lt
                    nurodytais kontaktais, Jūsų asmens duomenys bus naudojami šio paklausimo administravimui
                    (susipažinimui, atsakymo parengimui);
                </li>
                <li>
                    savo teisėtų interesu gynybai &ndash; jei tai būtų reikalinga, Jūsų asmens duomenys gali būti
                    panaudoti ginant savo teisėtus interesus, įskaitant reputaciją, teismuose, ikiteisminėse ginčų
                    sprendimo institucijose bei kitose kompetentingose institucijose.
                </li>
            </ul>
            <p>
                <strong>4. Kokią informaciją turėčiau Jums pateikti ir kodėl?</strong>
            </p>
            <p>Pateikdami užsakymą Jūs turėtumėte pateikti šią informaciją apie save:</p>
            <ul>
                <li>savo vardą ir pavardę;</li>
                <li>telefono numerį;</li>
                <li>
                    prekių pristatymo adresą (miestas, adresas, pašto kodas) arba pasirinktą
                    paštomatą/terminalą ar pašto skyrių, į kurį turi būti pristatomos Jūsų užsakytos
                    prekės.
                </li>
            </ul>
            <p>Be šios informacijos mes negalėsime įvykdyti Jūsų užsakymo ar pristatyti Jums prekių.</p>
            <p>
                <strong>5. Koks yra teisinis informacijos apie mane rinkimo pagrindas?</strong>
            </p>
            <p>Jūsų asmens duomenys yra renkami, naudojami bei saugomi teisėtai, nes:</p>
            <ul>
                <li>
                    Jūsų asmens duomenis pateikto užsakymo vykdymo ir prekių pristatymo tikslu mes naudojame sudarytos
                    pirkimo-pardavimo sutarties vykdymo pagrindu, kurią su mumis sudarote pateikdami užsakymą (BDAR 6
                    str. 1 d. b p.);
                </li>
                <li>
                    Jūsų asmens duomenys yra reikalingi, kad būtų galima tinkamai įvykdyti taikomas teisines prievoles
                    buhalterinės apskaitos bei dokumentų archyvavimo srityse (BDAR 6 str. 1 d. c p.);
                </li>
                <li>
                    gaunamų užklausų administravimui (susipažinimui, atsakymų rengimui) yra remiamasi teisėto intereso
                    pagrindu (BDAR 6 str. 1 d. f p.), o jei Jūsų užklausa susijusi su Jūsų užsakymu &ndash; ji bus
                    laikoma pirkimo-pardavimo sutarties dalimi, todėl bus laikoma, kad ji yra pirkimo-pardavimo
                    sutarties dalis, todėl šie asmens duomenys reikalingi pirkimo-pardavimo sutarties vykdymui
                    (BDAR 6 str. 1 d. b p.);
                </li>
                <li>
                    Jūsų asmens duomenų naudojimui teisių gynimui teismuose ar kitose valstybės institucijose
                    vadovaujantis teisėto intereso pagrindu (BDAR 6 str. 1 d. f p.).
                </li>
            </ul>
            <p>
                <strong>6. Ar Jūs renkate jautrią informacija apie mane?</strong>
            </p>
            <p>
                Jautri informacija apie Jus nėra renkama ir, jei ji nėra aktuali Jūsų pateiktam ar planuojamam
                užklausai, prašome jos neteikti. Jei vis dėl to tokia informacija bus pateikta, bus laikoma, kad
                davėte sutikimą šios informacijos rinkimui, naudojimui bei saugojimui (BDAR 9 str. 2 d. a p.).
            </p>
            <p>
                <strong>7. Ar dalinatės mano informacija su kitais subjektais?</strong>
            </p>
            <p>Informacija apie Jus gali būti perduota:&nbsp;</p>
            <ul>
                <li>
                    prekybos tarpininkui &ndash; bendrovei MB &bdquo;Pavojingos idėjos&ldquo;, kuri valdo
                    lietuviskapreke.lt platformą;
                </li>
                <li>buhalterinių paslaugų teikėjams;</li>
                <li>archyvavimo paslaugų teikėjams;</li>
                <li>duomenų saugyklų paslaugų teikėjams;</li>
                <li>el. pašto paslaugų teikėjams, jei užklausas mums siųsite el. paštu;</li>
                <li>
                    teisines paslaugas teikiančioms bendrovėms, advokatų kontoroms, kiek tai reikalinga teisėtų interesų
                    gynybai;
                </li>
                <li>
                    teismams, ikiteisminėms ginčų sprendimo institucijoms, kiek tai reikalinga teisėtų interesų gynybai;
                </li>
                <li>antstoliams, kiek tai reikalinga priteistų sumų išieškojimui.</li>
            </ul>
            <p>
                <strong>8. Kiek laiko saugote informaciją apie mane?</strong>
            </p>
            <p>Jūsų informacija bus saugoma:</p>
            <ul>
                <li>
                    jei jūsų užklausą susijusi su Jūsų užsakymu, ji bus saugoma 10 metų po pirkimo-pardavimo sutarties
                    pabaigos, t. y. po prekių pristatymo;
                </li>
                <li>
                    jei pateikėte skundą, prašymą ar kitokią užklausą, kuri nėra susijusi su Jūsų užsakymu, ji
                    bus saugoma 1 metus nuo galutinio sprendimo priėmimo;
                </li>
                <li>informaciją apie Jūsų užsakymą, įskaitant išrašytą sąskaitą, saugosime 10 metų;</li>
                <li>
                    teismams ar kitoms ginčus nagrinėjančioms ar teisėsaugos institucijoms teikiami dokumentai saugomi 1
                    metus po galutinio sprendimo priėmimo;
                </li>
                <li>teismų vykdomieji raštai, antstolių patvarkymai saugomi 10 metų po mokėjimų pabaigos.</li>
            </ul>
            <p>
                <strong>9. Kokių veiksmų galiu imtis dėl savo informacijos Jūsų bendrovėje?</strong>
            </p>
            <p>
                Jei norite imtis žemiau nurodytų veiksmų, prašome kreiptis 10 skyriuje nurodytais kontaktais.
                Atkreipkite dėmesį, kad šioms teisėms gali būti taikomos įstatymų numatytos išimtys bei
                ribojimai. Jūs turite šias teises duomenų apsaugos srityje:
            </p>
            <ul>
                <li>
                    pateikti prašymą susipažinti su turima informacija apie Jus, jei yra tvarkomi Jūsų asmens
                    duomenis, iš kurių galime nustatyti Jūsų tapatybę;
                </li>
                <li>pateikti prašymą ištaisyti ar papildyti turimą informaciją apie Jus;</li>
                <li>
                    pateikti prašymą ištrinti apie Jus, kai:
                    <ul>
                        <li>Jūsų duomenys tvarkomi sutikimo pagrindu;</li>
                        <li>Jūsų duomenys tvarkomi neteisėtai;</li>
                        <li>
                            Jūsų duomenys tvarkomi teisėto intereso pagrindu ir Jūs nuginčijate mūsų teisėtą interesą;
                        </li>
                        <li>Jūsų duomenys nebėra reikalingi, kad būtų pasiekti tikslai, kuriems jie buvo renkami;</li>
                        <li>mums taikoma teisinė prievolė ištrinti informaciją apie Jus;</li>
                    </ul>
                </li>
                <li>
                    pateikti mums prašymą apriboti apie Jus turimos informacijos tvarkymą kai ginčijate duomenų
                    tikslumą ar prieštaraujate duomenų tvarkymui, nesutinkate, kad būtų ištrinti
                    neteisėtai tvarkomi Jūsų duomenys, ar duomenų Jums reikia, siekiant pareikšti, vykdyti arba
                    apginti teisinius reikalavimus;
                </li>
                <li>
                    ginčyti Jūsų informacijos rinkimą, naudojimą ir saugojimą, kai Jūsų duomenys tvarkomi teisėto
                    intereso pagrindu;
                </li>
                <li>
                    pateikti prašymą išeksportuoti Jūsų duomenis jei duomenis mums pateikėte susistemintu,
                    įprastai naudojamu formatu ir davėte sutikimą tokių duomenų tvarkymui arba turime tvarkyti
                    šiuos duomenis siekdami įvykdyti sutartį su Jumis;
                </li>
                <li>pateikti skundą Valstybinei duomenų apsaugos inspekcijai (daugiau informacijos vdai.lrv.lt).</li>
            </ul>
            <p>
                <strong>10. Kaip galite man padėti?</strong>
            </p>
            <p>
                Jeigu Jūs turite klausimų, komentarų ar nusiskundimų, susijusių su tuo, kaip yra renkami, naudojami ir
                saugomi Jūsų asmens duomenys, pagalba Jums dėl to bus suteikta kreipiantis el. pašto adresu
                ${email || '[...]'}.
            </p>
        </div>
    `
}
